
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';

interface SEOInfoCardProps {
  seoTitle?: string | null;
  seoDescription?: string | null;
  seoKeywords?: string[] | null;
}

const SEOInfoCard: React.FC<SEOInfoCardProps> = ({ seoTitle, seoDescription, seoKeywords }) => {
  if (!seoTitle && !seoDescription && (!seoKeywords || seoKeywords.length === 0)) {
    return null;
  }

  return (
    <Card className="mt-8 border-blue-200 bg-blue-50">
      <CardContent className="p-6">
        <h3 className="text-lg font-semibold mb-4 text-blue-800">SEO Information</h3>
        {seoTitle && (
          <div className="mb-3">
            <span className="font-medium text-blue-700">SEO Title:</span>
            <p className="text-blue-600">{seoTitle}</p>
          </div>
        )}
        {seoDescription && (
          <div className="mb-3">
            <span className="font-medium text-blue-700">SEO Description:</span>
            <p className="text-blue-600">{seoDescription}</p>
          </div>
        )}
        {seoKeywords && seoKeywords.length > 0 && (
          <div>
            <span className="font-medium text-blue-700">SEO Keywords:</span>
            <p className="text-blue-600">{seoKeywords.join(', ')}</p>
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default SEOInfoCard;
